module.exports = __webpack_public_path__ + "f2c72c12e473db657b6f061871c24289.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/clustergrammer_logo.png
// module id = 8
// module chunks = 0